module.exports = __webpack_public_path__ + "img/process_img01.94030b24.png";